export default __webpack_public_path__ + "static/media/8.c1b4d5b2.png";